import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PureComponent } from 'react';
import { QueryPreviewTabs } from '../types.js';
import { TreeView } from './TreeView.js';
import { renderTabPanelId, renderTabPanelButtonId } from '../utils/a11y.js';
const rootProps = {
    'aria-labelledby': renderTabPanelButtonId(QueryPreviewTabs.apiConfig),
    id: renderTabPanelId(QueryPreviewTabs.apiConfig),
    role: 'tabpanel',
};
export class QueryPreviewApi extends PureComponent {
    constructor() {
        super(...arguments);
        this.shouldExpandApiStateNode = (keyPath, value, layer) => {
            const lastKey = keyPath[keyPath.length - 1];
            return layer <= 1 && lastKey !== 'config';
        };
    }
    render() {
        const { apiStats, isWideLayout, apiState } = this.props;
        if (!apiState) {
            return null;
        }
        const hasMutations = Object.keys(apiState.mutations).length > 0;
        const hasQueries = Object.keys(apiState.queries).length > 0;
        return (_jsxs("article", { ...rootProps, css: (theme) => ({
                display: 'block',
                overflowY: 'auto',
                padding: '0.5em 0',
                color: theme.TAB_CONTENT_COLOR,
                '& h2': {
                    color: theme.ULIST_STRONG_COLOR,
                    padding: '0.5em 1em',
                    fontWeight: 700,
                },
                '& h3': {
                    color: theme.ULIST_STRONG_COLOR,
                },
            }), children: [_jsx("h2", { children: apiState.config.reducerPath }), _jsx(TreeView, { before: _jsx("h3", { children: "State" }), data: apiState, shouldExpandNodeInitially: this.shouldExpandApiStateNode, isWideLayout: isWideLayout }), apiStats && (_jsxs(_Fragment, { children: [_jsx(TreeView, { before: _jsx("h3", { children: "Tally" }), data: apiStats.tally, isWideLayout: isWideLayout }), hasQueries && (_jsx(TreeView, { before: _jsx("h3", { children: "Queries Timings" }), data: apiStats.timings.queries, isWideLayout: isWideLayout })), hasMutations && (_jsx(TreeView, { before: _jsx("h3", { children: "Mutations Timings" }), data: apiStats.timings.mutations, isWideLayout: isWideLayout }))] }))] }));
    }
}
